import { Injectable } from '@angular/core';
import { Config } from 'src/infrastructure/config';
import { HttpClient } from '@angular/common/http';
import { createRequestRegistrationModel } from 'src/models/requestModels/user/createRegistrationRequestModel';
import { AuthTokenDTO } from 'src/models/DTO/token/authToken';
import { createLoginRequestModel } from 'src/models/requestModels/login/createLoginRequestModel';


@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  private createUserURL : string = Config.api + "user/auth/register";
  private emailConfirmationURL : string = Config.api + "api/register";
  private userLoginURL : string = Config.api + "user/auth/login";

  constructor(private httpClient: HttpClient) { }

  public createRegistration(registration: createRequestRegistrationModel) {
    return this.httpClient.post(this.createUserURL, registration);
  }

   public confirmEmail(registration: createRequestRegistrationModel)  {
    return this.httpClient.post<any>(this.emailConfirmationURL, registration);
  }

  public loginUser(userRequestModel: createLoginRequestModel)  {
    return this.httpClient.post<AuthTokenDTO>(this.userLoginURL, userRequestModel);
  }
}
